import { TimeSeriesMeasurement } from "../../timeseries-statistics/model/TimeSeriesMeasurement.model";
import { Timestamp } from "../../timeseries-statistics/model/Timestamp.model";

export interface DeviceAvailabilityMeasurementModel {
  time: Timestamp;
  availability: number;
}

export const mapDeviceAvailabilityMeasurementModelToTimeSeriesMeasurement = (deviceAvailabilityMeasurementModel: DeviceAvailabilityMeasurementModel) : TimeSeriesMeasurement => ({
  time: new Date(deviceAvailabilityMeasurementModel.time),
  value: deviceAvailabilityMeasurementModel.availability
});